"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PotencyMG = void 0;
const decimal_js_1 = require("decimal.js");
/**
 * Potency model in milligrams
 * Equivalent to Java's PotencyMG class
 */
class PotencyMG {
    constructor() {
        this.thc = new decimal_js_1.Decimal(0);
        this.cbd = new decimal_js_1.Decimal(0);
        this.cbn = new decimal_js_1.Decimal(0);
        this.thca = new decimal_js_1.Decimal(0);
        this.cbda = new decimal_js_1.Decimal(0);
        this.cbg = new decimal_js_1.Decimal(0);
        // Additional cannabinoids that might be present
        this.cbga = new decimal_js_1.Decimal(0);
        this.cbca = new decimal_js_1.Decimal(0);
        this.delta8 = new decimal_js_1.Decimal(0);
        this.delta10 = new decimal_js_1.Decimal(0);
        this.thcv = new decimal_js_1.Decimal(0);
        this.cbdv = new decimal_js_1.Decimal(0);
        this.cbc = new decimal_js_1.Decimal(0);
        // Transient flags (not serialized)
        this.thcBatch = true;
        this.cbdBatch = true;
        this.cbdaBatch = true;
        this.thcaBatch = true;
        this.cbnBatch = true;
        this.cbgBatch = true;
        this.totalPotency = true; // indicate if is total potency or per serving
        this.mgPotency = true; // indicate if is potency mg or percent
        // Initialize with zeros
    }
    /**
     * Create PotencyMG from simple numbers
     */
    static fromNumbers(values) {
        const potency = new PotencyMG();
        if (values.thc !== undefined)
            potency.thc = new decimal_js_1.Decimal(values.thc);
        if (values.cbd !== undefined)
            potency.cbd = new decimal_js_1.Decimal(values.cbd);
        if (values.cbn !== undefined)
            potency.cbn = new decimal_js_1.Decimal(values.cbn);
        if (values.thca !== undefined)
            potency.thca = new decimal_js_1.Decimal(values.thca);
        if (values.cbda !== undefined)
            potency.cbda = new decimal_js_1.Decimal(values.cbda);
        if (values.cbg !== undefined)
            potency.cbg = new decimal_js_1.Decimal(values.cbg);
        return potency;
    }
    /**
     * Get total THC (THC + THCA * 0.877)
     */
    getTotalThc() {
        return this.thc.plus(this.thca.times(0.877));
    }
    /**
     * Get total CBD (CBD + CBDA * 0.877)
     */
    getTotalCbd() {
        return this.cbd.plus(this.cbda.times(0.877));
    }
}
exports.PotencyMG = PotencyMG;
//# sourceMappingURL=PotencyMG.js.map